/* AutoAssignVeilComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./AutoAssignVeilRenderer");

class AutoAssignVeilComponent extends EventEmitter {
    constructor(logger, hasSelection) {
        super();
        this._logger = logger;
        this._scope = hasSelection ? "selection" : "all";
        this._renderer = new Renderer(this, hasSelection);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    get scope() {
        return this._scope;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "AutoAssignVeilComponent.shutdown() error.");
            }
        );
    }

    setScope(scope) {
        this._scope = scope;
    }

    cancel() {
        const err = new Error("user rejected");
        err.userRejected = true;
        this._context.reject(err);
    }

    schedule(name) {
        this._context.resolve({scope: this._scope, action: "schedule", name});
    }

    runNow() {
        this._context.resolve({scope: this._scope, action: "runNow"});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /*******************************************/
}

module.exports = AutoAssignVeilComponent;
